export const questionsAsk = [
  "What is digital marketing?",
  "How is digital marketing similar to traditional marketing?",
  "Why is an online presence necessary for businesses today?",
  "What are the benefits of having a strong digital presence?",
  "Why is it important to stay updated with digital marketing trends?",
  "What are the core disciplines of digital marketing?",
  "What is the Customer Value Journey?",
  "How does the Customer Value Journey help in business growth?",
  "What are the 8 stages of the Customer Value Journey?",
  "Why is understanding the Customer Value Journey crucial for marketers?",
  "What is content marketing?",
  "How can content marketing attract prospects?",
  "What types of content can be used at the top of the funnel?",
  "What is the role of content marketing in the evaluation stage of the funnel?",
  "What content types are suitable for converting leads into customers?",
  "How does content marketing support the sales process?",
  "What is meant by 'perfect' content?",
  "How does content marketing fit into the overall digital marketing strategy?",
  "What is a Lead Magnet?",
  "What is the Content Lifecycle?",
  "What is digital advertising?",
  "How does paid traffic differ from organic traffic?",
  "What are the top three sources of paid traffic?",
  "How can businesses control paid traffic?",
  "What are the advantages of using paid traffic?",
  "How can paid traffic complement organic traffic?",
  "What is the difference between Google and Facebook ads?",
  "What makes YouTube ads unique?",
  "How should ads be targeted based on the customer journey?",
  "What are the five key elements of a high-performing ad campaign?",
  "What is social media marketing?",
  "How does the Social Success Cycle work?",
  "How can businesses attract fans and followers through social media?",
  "What strategies are effective for engaging social media audiences?",
  "How can social media be used to drive sales?",
  "What role does content play in social media marketing?",
  "How important is community management in social media marketing?",
  "What are some best practices for social media marketing?",
  "How can businesses measure social media marketing success?",
  "What are the challenges of social media marketing?",
  "Why is email marketing still relevant today?",
  "How can email marketing help businesses grow?",
  "What are some best practices for email marketing?",
  "How can email marketing be used to guide customers through the Customer Value Journey?",
  "What metrics should be tracked in email marketing?",
  "What types of emails are effective for engaging subscribers?",
  "How can businesses improve their email open rates?",
  "What role does personalization play in email marketing?",
  "How can email marketing support other digital marketing efforts?",
  "What are the common pitfalls in email marketing?",
  "What is search marketing?",
  "How has search marketing changed in recent years?",
  "What are the key components of search engine optimization (SEO)?",
  "How can search marketing drive website traffic?",
  "What strategies can improve a website's search engine ranking?",
  "What is the role of keywords in search marketing?",
  "How does SEO support other digital marketing disciplines?",
  "What tools can help with search marketing?",
  "How can businesses measure the success of their search marketing efforts?",
  "What are common SEO mistakes to avoid?",
  "What is website analytics?",
  "Why are website analytics important for digital marketers?",
  "How can analytics help identify what's working and what's not?",
  "What are the key metrics to track in website analytics?",
  "How can businesses use analytics to improve their marketing strategies?",
  "What tools are available for website analytics?",
  "How can website analytics guide decision-making in digital marketing?",
  "What are the challenges of using website analytics?",
  "How can analytics help in understanding customer behavior?",
  "What role does data play in digital marketing?",
  "What is conversion rate optimization (CRO)?",
  "Why is CRO critical to digital marketing success?",
  // "What are the key steps in the CRO process?",
  "How can CRO improve marketing campaign performance?",
  "What are common techniques for optimizing conversion rates?",
  "How can A/B testing be used in CRO?",
  "What metrics are important in CRO?",
  "How can CRO be integrated into the overall digital marketing strategy?",
  "What are the challenges of implementing CRO?",
  "How does CRO contribute to business growth?",
  "How do digital marketing strategies differ for B2B and B2C companies?",
  "What role does branding play in digital marketing?",
  "How can digital marketing tactics be aligned with business goals?",
  "What are the best practices for creating a digital marketing strategy?",
  "How does customer feedback influence digital marketing?",
  "What is the importance of having a mobile-friendly digital marketing approach?",
  "How can businesses stay updated with digital marketing trends?",
  "What are the ethical considerations in digital marketing?",
  "How can businesses leverage user-generated content in their digital marketing?",
  "What are some common challenges faced by digital marketers today?",
  "How can businesses create a multi-channel digital marketing strategy?",
  "What is the role of automation in digital marketing?",
  "How can artificial intelligence be used in digital marketing?",
  "What are the key considerations when scaling a digital marketing strategy?",
  "How can businesses optimize their digital marketing budget?",
  "What is the importance of storytelling in digital marketing?",
  "How does influencer marketing fit into digital marketing strategies?",
  "How can businesses use webinars as part of their digital marketing efforts?",
  "What are the future trends in digital marketing?",
  "How can businesses measure the overall ROI of their digital marketing efforts?",
];